import * as React from 'react';
import { Res } from 'core/api';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';
import { PaymentDirection, Transaction, TransactionTable, assertAreExternalTransactions } from './ExternalPaymentsService.Common';
import { ActionButtonDefinition } from 'core/ui';
import { Modal } from 'core/ui-next/modal';
import { PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';

export class ConfirmCancellationScreen extends PosStatelessScreenClassComponent<{
	direction: PaymentDirection,
	externalTransactions: Transaction[]
} & Modal.Actions<void>> {

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected getScreenId(): string {
		return 'CONFIRM_PAYMENT_CANCELLATION';
	}

	protected getTitle(): string {
		return Res.Common.WARNING();
	}

	protected getImage() {
		return Images.Warning;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [null, null, null, null, null, null];
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected useKeyboard(): boolean {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getContent(): React.ReactNode {

		const { direction, externalTransactions } = this.props;

		const problemDescription = direction === 'PAY'
			? Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_PAY_PROBLEM_DESCRIPTION()
			: Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_REFUND_PROBLEM_DESCRIPTION();

		const continueButtonText = direction === 'PAY'
			? Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_PAY_CONTINUE_BTN()
			: Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_REFUND_CONTINUE_BTN();

		const backButtonText = Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_BACK_BTN();

		const nextAction = direction === 'PAY'
			? Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_PAY_NEXT_ACTION()
			: Res.Web.EXTERNAL_PAYMENT_CONFIRM_CANCELLATION_REFUND_NEXT_ACTION();

		return <div className='p-m'>
			<p className='alert alert-danger m-b-md text-16' style={{ display: 'flex', alignItems: 'baseline' }}>
				<span className='fa fa-exclamation-circle m-r-sm'></span>{problemDescription}
			</p>

			{/* OJO: Los componentes quedan un poco juntos en PC, pero es para que en el Castles S1F2 quepan sin scroll */}

			<TransactionTable externalTransactions={externalTransactions} />

			<p className='m-t-md font-bold text-16 text-center'>
				{nextAction}
			</p>

			<div className='m-t-md m-b-md'>
				<UI.Button buttonStyle='primary' className='btn-block btn-lg' style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}} onClick={() => this.cancel()}>
					<Images.BackAlt className='m-r-sm' />
					<span>{backButtonText}</span>
				</UI.Button>
			</div>

			<div>
				<UI.Button buttonStyle='primary' outline className='btn-block btn-lg' style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}} onClick={() => this.close()}>
					<Images.Warning className='m-r-sm' />
					<span>{continueButtonText}</span>
				</UI.Button>
			</div>
		</div>;
	}

	static async confirm(direction: PaymentDirection, externalTransactions: Transaction[]): Promise<{ nextAction: 'continue-with-cancellation' | 'go-back' }> {
		assertAreExternalTransactions(...externalTransactions);

		// OJO: A diferencia del WarnBeforeUndoing, no hace falta el type porque aquí siempre estamos en el caso de
		// cancelar una operación que afecta a un cliente, por lo que los mensajes son siempre iguales.

		const result = await Modal.show(ConfirmCancellationScreen, { direction, externalTransactions });
		return { nextAction: result.ok ? 'continue-with-cancellation' : 'go-back' };
	}
}
